export default {
  getExchangeEmail: (state) => state.exchangeEmail,
};
